import { Component, Input, OnInit } from '@angular/core';
import {BookingType, SavingType} from "@afidium/ts-facade";
import { Yii } from "../../interfaces/Yii";
import { ECostOrRetail } from "../booking-information/components/booking-price-card/booking-price-card.enum";
import { FareOptimisationType } from "@afidium/ts-facade/model/fareOptimisationType";
import { FareOptimisationOfferType } from "@afidium/ts-facade/model/fareOptimisationOfferType";
import { OfferType } from "@afidium/ts-facade/model/offerType";
import { IFareOptimisationRow } from "libraries/interfaces/fare-optimisation/IFareOptimisation";


class Wording {
    public readonly title: string = Yii.t('wui-shared-js', 'Optimisation tarifaire');
}

@Component({
    selector: 'fare-optimisation-list',
    template: `
        <div class="row" *ngFor="let fareOptimisationByPrice of fareOptimisationsByPrice">
            <div>
                <tarifications-header [booking]="booking"
                                      [costOrRetail]="costOrRetail"
                                      [price]="fareOptimisationByPrice.bookingPrice"
                                      [showLink]="false"
                                      [showReturnBtn]="true"></tarifications-header>
            </div>
            <div>
                <tarifications-header
                        *ngFor="let fareOptimisation of fareOptimisationByPrice.optimisationOffersWithDifferences"
                        [booking]="booking"
                        [price]="fareOptimisation.offer.priceArray[0]"
                        [costOrRetail]="costOrRetail"
                        [differences]="fareOptimisation.differenceArray"
                        [bookingSyscode]="bookingSyscode"
                        [offerId]="fareOptimisation.offerId"
                        [savingPrice]="fareOptimisation.savingPrice.cost"
                        [tarificationPrice]="fareOptimisationByPrice.bookingPrice"
                        [showReturnBtn]="true"
                        [whenLastUpdated]="fareOptimisation.whenLastUpdated">
                </tarifications-header>
            </div>
        </div>
    `,
    styles: [`
        .row {
            display: flex;
            flex-direction: row;
        }

        .row > div {
            flex: 1
        }
    `
    ]
})
export class FareOptimisationListComponent implements OnInit {

    @Input()
    public fareOptimisation: FareOptimisationType;

    @Input()
    public booking: BookingType;

    @Input()
    public bookingSyscode: string;

    public costOrRetail: string = ECostOrRetail.cost;

    public fareOptimisationsByPrice: IFareOptimisationRow[] = [];

    public loaded: boolean = false;

    public wording: Wording = new Wording();

    public ngOnInit(): void {
        this.formatOptimisations();
    }

    private formatOptimisations(): void {
        this.fareOptimisation?.fareOptimisationOfferToBeProcessed?.fareOptimisationOfferArray.forEach((fareOptimisationOffer: FareOptimisationOfferType): void => {
            const isBookingPriceHere: number = this.fareOptimisationsByPrice
                .findIndex((item: IFareOptimisationRow): boolean => {
                    return item.bookingPrice[this.costOrRetail]?.signature === fareOptimisationOffer.price[this.costOrRetail]?.signature;
                });
            const optimisationOffer: OfferType = this.getOfferFromOfferArray(fareOptimisationOffer.offer.signature, this.fareOptimisation.offerArray);
            if (isBookingPriceHere > -1) {
                this.fareOptimisationsByPrice[isBookingPriceHere].optimisationOffersWithDifferences.push({
                    offer: optimisationOffer,
                    offerId: fareOptimisationOffer?.offer?.dbId?.toString(),
                    differenceArray: fareOptimisationOffer.differenceArray,
                    savingPrice: fareOptimisationOffer.savingArray
                        .find((saving: SavingType): boolean => !saving.cost?.baseArray?.length),
                    // @ts-ignore
                    whenLastUpdated: fareOptimisationOffer.whenLastUpdated
                });
            } else {
                this.fareOptimisationsByPrice.push({
                    optimisationOffersWithDifferences: [{
                        offer: optimisationOffer,
                        offerId: fareOptimisationOffer?.offer?.dbId?.toString(),
                        differenceArray: fareOptimisationOffer.differenceArray,
                        savingPrice: fareOptimisationOffer.savingArray
                            .find((saving: SavingType): boolean => Boolean(saving.cost?.baseArray?.length)),
                        // @ts-ignore
                        whenLastUpdated: fareOptimisationOffer.whenLastUpdated
                    }],
                    bookingPrice: fareOptimisationOffer.price
                });
            }
        });
    }

    private getOfferFromOfferArray(offerSignature: string, offerArray: OfferType[]): OfferType {
        return offerArray.find((offer: OfferType): boolean => offer.signature === offerSignature);
    }
}
